const envConfig = {
  endpoint: 'http://localhost:21242/v1/',
  endpointv2: 'http://localhost:21242/v2/',
};

export default envConfig;
